/**
 * TBT-FIX: rend la main au navigateur entre deux blocs synchrones coûteux
 * (structuredClone, constructeurs…) pour éviter une longue tâche unique qui
 * fait exploser le Total Blocking Time Lighthouse (>50 ms par slice).
 *
 * Ordre de préférence :
 * 1. `scheduler.yield()` (Chrome récent) — cède explicitement au scheduler.
 * 2. Double `requestAnimationFrame` + `queueMicrotask` — sépare mieux les tranches
 *    qu’un seul rAF (souvent dans la même macrotask que le code parent).
 */
export default async function yieldMainThread(): Promise<void> {
  if (typeof window === "undefined") {
    return;
  }

  const sched = (
    globalThis as typeof globalThis & {
      scheduler?: { yield?: () => Promise<void> };
    }
  ).scheduler;
  if (typeof sched?.yield === "function") {
    await sched.yield();
    return;
  }

  await new Promise<void>((resolve) => {
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        queueMicrotask(() => resolve());
      });
    });
  });
}
